<template>
  <div
      v-if="ready"
      class="warranty-card">
    <div class="data-item">
      <span class="label">Status:</span>
      <strong
          :class="{
            value: true,
            'in-warranty': data.in_warranty,
            'out-of-warranty': !data.in_warranty
          }">
        {{ data.status }}
      </strong>
    </div>

    <div class="data-item">
      <span class="label">Activation Date:</span>
      <span
          v-if="data.activation_date"
          class="value">
        <time-zone-formatter :current-time="activationDate" />
      </span>
      <span
          v-else
          class="value">N/A</span>
    </div>

    <div class="data-item">
      <span class="label">Limited Expiration:</span>

      <span
          v-if="data.standard_expiration"
          class="value">
        <time-zone-formatter :current-time="standardExpirationDate" />
      </span>
      <span
          v-else
          class="value">N/A</span>
    </div>

    <div class="data-item">
      <span class="label">Extended Warranty:</span>
      <strong class="value">
        {{ data.extended_warranty ? 'Yes' : 'No' }}
      </strong>
    </div>

    <div
        v-if="data.notes"
        class="notes">
      <strong class="notes-title">Notes:</strong>
      {{ data.notes }}
    </div>
  </div>
</template>

<script>
import { isDate } from "lodash";

const isValidDate = (dateStr) => {
  const date = new Date(dateStr);
  return isDate(date);
};
export default {
  name: "WarrantyInfo",
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    ready() {
      return this.data.hasOwnProperty("in_warranty");
    },
    standardExpirationDate() {
      let dt = this.data.standard_expiration;
      return isValidDate(dt) ? Date.parse(dt) : "";
    },
    activationDate() {
      let dt = this.data.activation_date;
      return isValidDate(dt) ? Date.parse(dt) : "";
    },
  },
};
</script>
<style lang="scss" scoped>
.warranty-card {
  font-size: 0.9rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  width: 300px;
  font-family: sans-serif;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  .card-title {
    font-size: 1.2em;
  }

  .warranty-status {
    font-size: 0.8em;
    font-weight: bold;

    &.in-warranty {
      color: green;
    }

    &.out-of-warranty {
      color: red;
    }
  }
}

.data-item {
  margin-bottom: 8px;
  display: flex;
  align-items: baseline;

  .label {
    color: #999999;
    font-weight: bold;
    word-break: break-word;
    width: 120px;
    display: inline-block;
  }

  .value {
    margin-left: 8px;

    &.in-warranty {
      color: green;
    }

    &.out-of-warranty {
      color: $--color-milano-red;
    }
  }
}

.notes {
  margin-top: 12px;
  padding: 8px;
  background-color: #f9f9f9;
  border-radius: 4px;
  font-size: 0.9em;
  color: #777;
  word-break: break-word;
  text-align: left;

  .notes-title {
    color: #333;
    display: block;
    margin-bottom: 4px;
    font-weight: bold;
  }
}
</style>
